import axios from '../utils/request'

const MaterialCategory = () => {
  return axios.get('GetClassification', { })
}

// 中类维护时获取大类数据的接口
const MaterialCategory1 = () => {
  return axios.get('GetClassification1', { })
}

const MaterialSubgroupInfo = () => {
  return axios.get('GetMaterialSubgroupInfo', { })
}

const MaterialCategoryMove = (ClassificationID, move) => {
  return axios.get('MaterialCategoryMove?ClassificationID=' + ClassificationID + '&move=' + move, {
  })
}

const MiddleCategoriesMove = (AttributesID, move) => {
  return axios.get('MiddleCategoriesMove?AttributesID=' + AttributesID + '&move=' + move, {
  })
}

const MaterialSubgroupMove = (AttributesvalueID, move) => {
  return axios.get('MaterialSubgroupMove?Attributes_value_ID=' + AttributesvalueID + '&move=' + move, {
  })
}

const MiddleCategoriesInfo = (ClassificationID) => {
  return axios.get('GetMiddleCategoriesInfo?ClassificationID=' + ClassificationID, {
  })
}

const MaterialInformationList = (CurrentPage, pageSize) => {
  return axios.get('GetMaterialInformationList?CurrentPage=' + CurrentPage + '&pageSize=' + pageSize, {
  })
}

const MaterialModalSelectionData = (ClassificationID, id, type) => {
  return axios.get('GetMaterialModalSelectionData?ClassificationID=' + ClassificationID + '&Attribute_Warehouse_Product_id=' + id + '&type=' + type, {
  })
}

const QuantitativeRulesListApi = () => {
  return axios.get('GetQuantitativeRulesList', {})
}

const ChangeMaterialCategory = (loginInfo) => {
  return axios.post('ChangeMaterialCategory', {
    ...loginInfo
  })
}

const ChangeMiddleCategories = (loginInfo) => {
  return axios.post('ChangeMiddleCategories', {
    ...loginInfo
  })
}

const ChangeMaterialSubgroup = (loginInfo) => {
  return axios.post('ChangeMaterialSubgroup', {
    ...loginInfo
  })
}

const ChangeMaterialInformation = (loginInfo) => {
  return axios.post('ChangeMaterialInformation', {
    ...loginInfo
  })
}

const MaterialInformationList1 = (loginInfo) => {
  return axios.post('GetMaterialInformationList', {
    ...loginInfo
  })
}

const ChangeSingleWeightData = (loginInfo) => {
  return axios.post('ChangeSingleWeightData', {
    ...loginInfo
  })
}

const ChangeAuxiliaryQuantityData = (loginInfo) => {
  return axios.post('ChangeAuxiliaryQuantityData', {
    ...loginInfo
  })
}

export {
  MaterialCategory,
  ChangeMaterialCategory,
  MaterialCategoryMove,
  MiddleCategoriesInfo,
  ChangeMiddleCategories,
  MiddleCategoriesMove,
  MaterialCategory1,
  MaterialSubgroupInfo,
  ChangeMaterialSubgroup,
  MaterialSubgroupMove,
  MaterialInformationList,
  MaterialInformationList1,
  MaterialModalSelectionData,
  ChangeMaterialInformation,
  QuantitativeRulesListApi,
  ChangeSingleWeightData,
  ChangeAuxiliaryQuantityData
}
